module.exports = __webpack_public_path__ + "static/img/1_9_1.135d8d5b.jpg";